<footer class="footer" style="text-align:center">
	<a href="http://www.leafdev.com.br" target="_blank"><img src="../assets/img/LogosPG-01.png" alt="" style="padding-top: 10px; width: 100px;"/></a>
</footer>